import Domain from "./domain";
export default {
  methods: {
    getResources: async function(department) {
      let url = Domain.APP_DOMAIN + "customer/resources/data/details";
      if (department) {
        url = url + "?department=" + department;
      }
      try {
        let response = await this.axios.get(url, Domain.APP_HEADER);
        if (!response || !response.data) {
          throw Error("failed to fetch resource.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    getResourcesByName: async function(name, resourceId, department) {
      let link = "customer/resources/data/details?";
      var queries = [];
      if (department) {
        queries.push("department=" + department);
      }
      if (name) {
        queries.push("name=" + name);
      }
      if (resourceId) {
        queries.push("resources_id=" + resourceId);
      }
      link = link + queries.join("&");
      try {
        let response = await this.axios.get(
          Domain.APP_DOMAIN + link,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("failed to fetch resource.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    getResourcesByDepartment: async function(department) {
      try {
        let response = await this.axios.get(
          Domain.APP_DOMAIN +
            "customer/resources/data/details?department=" +
            department,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("failed to fetch resource.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    getResourcesByResourceType: async function(resourcetype) {
      try {
        let response = await this.axios.get(
          Domain.APP_DOMAIN +
            "customer/resources/data/details?resources_type=" +
            resourcetype,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("failed to fetch resource.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    getResourcesTypes: async function() {
      try {
        // ?name=&resources_id=
        let response = await this.axios.get(
          Domain.APP_DOMAIN + "customer/resources/type/details/",
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("failed to fetch resource.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    createResource: async function(resource) {
      try {
        let response = await this.axios.post(
          Domain.APP_DOMAIN + "customer/resources/data",
          resource,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("failed to fetch resource.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    createResourcesBulk: async function(resources) {
      try {
        let response = await this.axios.post(
          Domain.APP_DOMAIN + "customer/resources/data/bulk/json",
          resources,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("failed to fetch resource.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    createResourceTypeBulk: async function(resources) {
      try {
        let response = await this.axios.post(
          Domain.APP_DOMAIN + "customer/resources/type/bulk",
          resources,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("failed to fetch resource.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    createResourceType: async function(resource) {
      try {
        let response = await this.axios.post(
          Domain.APP_DOMAIN + "customer/resources/type",
          resource,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("failed to fetch resource.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    updateResource: async function(resource) {
      try {
        let response = await this.axios.put(
          Domain.APP_DOMAIN + "customer/resources/data",
          resource,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("failed to fetch resource.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    deleteResource: async function(resourceid) {
      try {
        let response = await this.axios.delete(
          Domain.APP_DOMAIN + "customer/resources/data/" + resourceid,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("failed to fetch resource.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    deleteResourceType: async function(resourceid) {
      try {
        let response = await this.axios.delete(
          Domain.APP_DOMAIN + "customer/resources/type/" + resourceid,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("failed to fetch resource.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    listResourcesInOut: async function(options, department) {
      let link =
        Domain.APP_DOMAIN +
        "customer/resources/data/traking/details?page=0&perpage=1000";
      if (options) {
        link = link + "&attendance_type=" + options;
      }
      if (department) {
        link = link + "&resources_department=" + department;
      }
      try {
        let response = await this.axios.get(
          // ?company&holder_type=staff&attendance_type=out&from_date=2019-11-23&to_date=2019-11-27&page=0&perpage=20&first_name=&last_name&mobile=,
          link,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("failed to fetch resource.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    signInResource: async function(rin) {
      try {
        let response = await this.axios.post(
          Domain.APP_DOMAIN + "customer/resources/data/sing/in",
          rin,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("failed to fetch resource.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    signOutResource: async function(rout) {
      try {
        let response = await this.axios.post(
          Domain.APP_DOMAIN + "customer/resources/data/sing/out",
          rout,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("failed to fetch resource.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    allStaff: async function() {
      try {
        let url =
          Domain.APP_DOMAIN +
          "customer/company/staff/details?page=0&perpage=10000";
        let response = await this.axios.get(url, Domain.APP_HEADER);
        if (!response || !response.data) {
          throw Error("failed to fetch resource.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    searchUser: async function(entity, fname, lname) {
      try {
        let url = Domain.APP_DOMAIN + "customer/company/" + entity + "/details";
        let params = [];
        if (fname) {
          params.push("first_name=" + fname);
        }
        if (lname) {
          params.push("last_name=" + lname);
        }

        if (params.length > 0) {
          url = url + "?" + params.join("&");
        }

        let response = await this.axios.get(url, Domain.APP_HEADER);
        if (!response || !response.data) {
          throw Error("failed to fetch resource.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    }
  }
};
